import React, { useEffect, useState, useRef } from 'react'
import Swal from 'sweetalert2';
import { addDoc, collection, doc, getDoc, getDocs, onSnapshot, orderBy, query, Timestamp, updateDoc, where } from 'firebase/firestore';
import { auth, db } from '../../firebase';
import "../../App.css";
import moment from 'moment';
import { useReactToPrint } from 'react-to-print';
import Menu from '../../panel/Menu';

function Datewisesale() {
    const Toast = Swal.mixin({
        toast: true,
        position: 'top-end',
        showConfirmButton: false,
        timer: 3000,
        timerProgressBar: true,
        didOpen: (toast) => {
            toast.addEventListener('mouseenter', Swal.stopTimer)
            toast.addEventListener('mouseleave', Swal.resumeTimer)
        }
    });
    useEffect(() => {
        auth.onAuthStateChanged((user) => {
            setUserData(user);
            fethUsers()
        });
    });
    const printRef = useRef();
    const [loading, setloading] = useState(false);
    const [loadincount, setloadincount] = useState(true);
    const [userData, setUserData] = useState();
    const [fromDate, setfromDate] = useState("");
    const [toDate, settoDate] = useState("");
    const [username, setusername] = useState("");
    const [bookingData, setbookingData] = useState([]);

    const fethUsers = async () => {
        try {
            if (userData) {
                if (loadincount) {
                    const docRef = doc(db, "users", userData.uid)
                    const docSnap = await getDoc(docRef)
                    if (docSnap.exists()) {
                        setusername(docSnap.data().username);
                        setloadincount(false)
                    }

                }
            }
        } catch (error) {
            console.log(error);
        }
    }


 const getReport = async () => {
    if (!fromDate || !toDate) {
        Toast.fire({ icon: "error", title: 'Please select From Date & To Date' });
        return;
    }

    setloading(true);
    setbookingData([]);

    const startOfDay = new Date(fromDate);
    startOfDay.setHours(0, 0, 0, 0);
    const endOfDay = new Date(toDate);
    endOfDay.setDate(endOfDay.getDate() + 1);

    // === 1. FETCH PAYMENT HISTORY ===
    const paymentSnapshot = await getDocs(query(
        collection(db, 'payhistory'),
        where('status', '==', 'Working'),
        where('createdAt', '>=', Timestamp.fromDate(startOfDay)),
        where('createdAt', '<', Timestamp.fromDate(endOfDay))
    ));

    const rawPayments = paymentSnapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));

    // Collect all payment mode IDs
    const allPaymodeIds = new Set();
    rawPayments.forEach(p => {
        if (p.paymode1) allPaymodeIds.add(p.paymode1);
        if (p.paymode2) allPaymodeIds.add(p.paymode2);
    });

    const paymodeMap = {};
    await Promise.all([...allPaymodeIds].map(async (id) => {
        const snap = await getDoc(doc(db, 'paymentmodes', id));
        if (snap.exists()) paymodeMap[id] = snap.data().paymode;
    }));

    const paymentHistoryData = rawPayments.map(p => ({
        id: p.id,
        data: p,
        paymode1: paymodeMap[p.paymode1] || '',
        paymode2: paymodeMap[p.paymode2] || '',
        amount1: p.amount1 || 0,
        amount2: p.amount2 || 0,
        createdat: moment(p.createdAt.toDate()).format('DD-MM-YYYY HH:mm:ss')
    }));

    // === 2. FETCH CHECKINS ===
    const checkinSnapshot = await getDocs(query(
        collection(db, 'checkindetails'),
        where('status', 'in', ['Booked', 'Checkout']),
        where('checkindate', '>=', moment(fromDate).format('YYYY-MM-DD')),
        where('checkindate', '<=', moment(toDate).format('YYYY-MM-DD'))
    ));

    const checkinDetailsData = checkinSnapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
    const uniqueCheckins = Array.from(new Map(checkinDetailsData.map(item => [item.bookingid, item])).values());
    const bookingIds = uniqueCheckins.map(i => i.bookingid);

    if (bookingIds.length === 0) {
        Toast.fire({ icon: "info", title: 'No bookings found in this date range.' });
        setloading(false);
        return;
    }

    // === 3. FETCH BOOKINGS ===
    const fetchBookingsInChunks = async (ids) => {
        const chunks = [];
        while (ids.length) chunks.push(ids.splice(0, 30));
        const results = {};

        await Promise.all(chunks.map(async chunk => {
            const snap = await getDocs(query(
                collection(db, 'bookings'),
                where('__name__', 'in', chunk)
            ));
            snap.forEach(doc => results[doc.id] = { id: doc.id, ...doc.data() });
        }));

        return results;
    };

    const bookingsDataMap = await fetchBookingsInChunks([...bookingIds]);

    // === 4. BATCH USER FETCH ===
    const uidSet = new Set(uniqueCheckins.map(c => c.uid).filter(Boolean));
    const userMap = {};
    const uidChunks = [...uidSet].reduce((acc, uid, i) => {
        const idx = Math.floor(i / 30);
        acc[idx] = acc[idx] || [];
        acc[idx].push(uid);
        return acc;
    }, []);

    await Promise.all(uidChunks.map(async chunk => {
        const snap = await getDocs(query(collection(db, 'users'), where('__name__', 'in', chunk)));
        snap.forEach(doc => {
            userMap[doc.id] = doc.data().username || "Unnamed";
        });
    }));

    // === 5. GROUP PAYMENTS BY BOOKING ===
    const paymentHistoryMap = {};
    paymentHistoryData.forEach(p => {
        const bid = p.data.bookingid;
        if (!paymentHistoryMap[bid]) paymentHistoryMap[bid] = [];
        paymentHistoryMap[bid].push(p);
    });

    // === 6. FINAL DATA COMBINE ===
    const finalData = await Promise.all(uniqueCheckins.map(async (checkin) => {
        const booking = bookingsDataMap[checkin.bookingid];
        if (!booking) return null;

        const username = userMap[checkin.uid] || "Unknown";
        const customerName = booking.customers?.custname || "";
        const mobileNo = booking.customers?.mobile || "";

        const roomamount = parseFloat(booking.rooamount || 0);
        const servicePerDay = parseFloat(booking.serviceamount || 0) / (parseFloat(booking.noofdays) || 1);
        const date1 = moment(booking.checkindate);
        const date2 = moment(checkin.checkindate);
        const dayDiff = Math.max(1, date2.diff(date1, 'days'));

        // Food order fetch (can be slow, but done in parallel)
        let foodTotal = 0;
        try {
            const foodSnapshot = await getDocs(query(
                collection(db, 'orders'),
                where('status', '==', 'Bill Pending'),
                where('bookingId', '==', checkin.bookingid),
                where('orderdate', '==', checkin.checkindate)
            ));
            foodSnapshot.forEach(doc => foodTotal += doc.data().totalamount || 0);
        } catch {}

        const payments = paymentHistoryMap[checkin.bookingid] || [];
        const paid = payments.reduce((sum, p) => sum + p.amount1 + p.amount2, 0);

        const dayAmount = roomamount + servicePerDay + foodTotal;
        const allTotal = dayAmount * dayDiff;
        const pending = allTotal - paid;

        return {
            ...checkin,
            booking,
            username,
            roomamount: roomamount.toFixed(0),
            serviceamount: servicePerDay.toFixed(0),
            foodamount: foodTotal.toFixed(0),
            totalamount: dayAmount.toFixed(0),
            alltoal: allTotal.toFixed(0),
            paidamount: paid.toFixed(0),
            pending: pending.toFixed(0),
            todayDays: dayDiff,
            paymentHistory: payments,
            customerName,
            mobileNo
        };
    }));

    setbookingData(finalData.filter(Boolean));
    setloading(false);
};



    const handlePrint = useReactToPrint({
        content: () => printRef.current,
    })

    const handleFromDate = (e) => {
        setfromDate(e.target.value)
        setloading(false)
    }
    const handleToDate = (e) => {
        settoDate(e.target.value)
        setloading(false)
    }

    return (
        <div>
            <Menu />
            <div className="content-wrapper">
                <section className="content mt-2">
                    <div className="container-fluid">
                        <button className="btn btn-secondary " >|| Datewise Booking Report ||</button><br /><br />
                        <div className="row">
                            <div className="col-md-12">
                                <div className="card card-primary card-outline">
                                    <div className="card-body">
                                        <div className='row'>
                                            <div className='col-sm-4'>
                                                <label>From Date</label>
                                                <input type='date' value={fromDate} onChange={handleFromDate} className='form-control' />
                                            </div>
                                            <div className='col-sm-4'>
                                                <label>To Date</label>
                                                <input type='date' value={toDate} onChange={handleToDate} className='form-control' />
                                            </div>
                                            <div className='col-sm-3'>
                                                <br />
                                                <button className='btn btn-info' onClick={getReport}>Get Report</button>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div className="card card-primary card-outline" ref={printRef}>
                                    <div className="card-body">
                                        <div className="row invoice-info">
                                            <div className="col-sm-12 invoice-col text-center">
                                                <address>
                                                    <h4>Dasara Executive</h4>
                                                    Chatrapati Shivaji Maharaj Chouk, Tuljapur, Dist - Dharashiv, MH - 413601<br />
                                                    Phone: +91 9975294940 |
                                                    Email:  dasaraexecutive@gmail.com<br />
                                                    Website:  www.dasaraexecutive.com
                                                </address>
                                            </div>
                                        </div>
                                        <div className='row'>
                                            <table className='customers '>
                                                <tr>
                                                    <th style={{ textAlign: "center" }}>From Date : {moment(fromDate).format('DD/MM/YYYY')}  </th>
                                                    <th style={{ textAlign: "center" }}><h5>DATEWISE BOOKING REPORT </h5></th>
                                                    <th style={{ textAlign: "center" }}>To Date : {moment(toDate).format('DD/MM/YYYY')}</th>
                                                </tr>
                                            </table>
                                            <table className="table table-bordered mt-4">
                                                <thead>
                                                    <tr>
                                                        <th>Date</th>
                                                        <th>Customer</th>
                                                        <th>Username</th>
                                                        <th>Room Amount</th>
                                                        <th>Service</th>
                                                        <th>Food</th>
                                                        <th>Total</th>
                                                        <th>All Total</th>
                                                        <th>Paid</th>
                                                        <th>Pending</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {Object.entries(
                                                        bookingData.reduce((acc, row) => {
                                                            if (!acc[row.checkindate]) acc[row.checkindate] = [];
                                                            acc[row.checkindate].push(row);
                                                            return acc;
                                                        }, {})
                                                    ).map(([date, rows]) => {
                                                        let dateRoomTotal = 0;
                                                        let dateServiceTotal = 0;
                                                        let dateFoodTotal = 0;
                                                        let dateTotal = 0;
                                                        let dateAllTotal = 0;
                                                        let datePaid = 0;
                                                        let datePending = 0;

                                                        return (
                                                            <React.Fragment key={date}>
                                                                {rows.map((row, index) => {
                                                                    dateRoomTotal += parseFloat(row.roomamount);
                                                                    dateServiceTotal += parseFloat(row.serviceamount);
                                                                    dateFoodTotal += parseFloat(row.foodamount);
                                                                    dateTotal += parseFloat(row.totalamount);
                                                                    dateAllTotal += parseFloat(row.alltoal);
                                                                    datePaid += parseFloat(row.paidamount);
                                                                    datePending += parseFloat(row.pending);

                                                                    return (
                                                                        <tr key={row.id}>
                                                                            <td>{index === 0 ? date : ""}</td>
                                                                            <td>{row.customerName}</td>
                                                                            <td>{row.username}</td>
                                                                            <td>{row.roomamount}</td>
                                                                            <td>{row.serviceamount}</td>
                                                                            <td>{row.foodamount}</td>
                                                                            <td>{row.totalamount}</td>
                                                                            <td>{row.alltoal}</td>
                                                                            <td>{row.paidamount}</td>
                                                                            <td>{row.pending}</td>
                                                                        </tr>
                                                                    );
                                                                })}
                                                                <tr style={{ backgroundColor: '#f2f2f2', fontWeight: 'bold' }}>
                                                                    <td colSpan="3">Total for {date}</td>
                                                                    <td>{dateRoomTotal.toFixed(0)}</td>
                                                                    <td>{dateServiceTotal.toFixed(0)}</td>
                                                                    <td>{dateFoodTotal.toFixed(0)}</td>
                                                                    <td>{dateTotal.toFixed(0)}</td>
                                                                    <td>{dateAllTotal.toFixed(0)}</td>
                                                                    <td>{datePaid.toFixed(0)}</td>
                                                                    <td>{datePending.toFixed(0)}</td>
                                                                </tr>
                                                            </React.Fragment>
                                                        );
                                                    })}
                                                </tbody>

                                                {/* Grand Total Row */}
                                                <tfoot>
                                                    <tr style={{ backgroundColor: '#d0e7ff', fontWeight: 'bold' }}>
                                                        <td colSpan="3">Grand Total</td>
                                                        <td>
                                                            {bookingData.reduce((sum, r) => sum + parseFloat(r.roomamount), 0).toFixed(0)}
                                                        </td>
                                                        <td>
                                                            {bookingData.reduce((sum, r) => sum + parseFloat(r.serviceamount), 0).toFixed(0)}
                                                        </td>
                                                        <td>
                                                            {bookingData.reduce((sum, r) => sum + parseFloat(r.foodamount), 0).toFixed(0)}
                                                        </td>
                                                        <td>
                                                            {bookingData.reduce((sum, r) => sum + parseFloat(r.totalamount), 0).toFixed(0)}
                                                        </td>
                                                        <td>
                                                            {bookingData.reduce((sum, r) => sum + parseFloat(r.alltoal), 0).toFixed(0)}
                                                        </td>
                                                        <td>
                                                            {bookingData.reduce((sum, r) => sum + parseFloat(r.paidamount), 0).toFixed(0)}
                                                        </td>
                                                        <td>
                                                            {bookingData.reduce((sum, r) => sum + parseFloat(r.pending), 0).toFixed(0)}
                                                        </td>
                                                    </tr>
                                                </tfoot>
                                            </table>



                                        </div>
                                    </div>

                                </div>
                                <center>
                                    <button className='btn btn-success' onClick={handlePrint}>Print Report</button>
                                </center>
                            </div>
                        </div>
                    </div>
                </section >

            </div>

        </div >

    )
}

export default Datewisesale
